import { render, staticRenderFns } from "./defectsPage.html?vue&type=template&id=526765a7&"
import script from "./defectsPage.vue?vue&type=script&lang=js&"
export * from "./defectsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports